// React
import { FC, useState } from 'react';
// Next
import dynamic from 'next/dynamic';
// Features
import CityMapsLegend from '@utmb/features/city-maps/CityMapsLegend';
import CityMapTabs from '@utmb/features/city-maps/CityMapsTabs';
import styles from '@utmb/features/city-maps/city-maps.module.scss';
// Design System
import { Button } from '@utmb/design-system/button/Button';
import { Col } from '@utmb/design-system/box/Box';
import { Spacer } from '@utmb/design-system/spacer/Spacer';
// Types
import { Slice } from '@utmb/types/slice-handler';
// Context, Utils
import { CityMapsProvider } from '../../contexts/CityMapsContext';
import { useTranslation } from 'next-i18next';
import SliceCityMapView from '@utmb/types/view/SliceCityMapView';

const CityMapsMap = dynamic(() => import('./CityMapsMap'), {
    ssr: false,
});

export const CityMaps: FC<Slice<SliceCityMapView>> = ({ id, cityMap: pois }) => {
    const [showLegend, setShowLegend] = useState(false);

    const { t } = useTranslation();

    const toggleLegend = (): void => {
        setShowLegend(!showLegend);
    };

    const buttonClasses = [styles.legend_button, showLegend && styles.legend_active].filter(Boolean).join(' ');

    return (
        <>
            {pois && pois.length && (
                <section id={id}>
                    <CityMapsProvider pois={pois}>
                        <CityMapTabs />
                        <Col className={styles.tab}>
                            <Spacer size="l" className="portrait-only" />
                            <div className={styles.map}>
                                {showLegend && <CityMapsLegend />}
                                <Button.Icon
                                    label={t(showLegend ? 'common.legend.hide' : 'common.legend.show')}
                                    className={buttonClasses}
                                    onPress={toggleLegend}
                                    variant={showLegend ? 'chevronDown' : 'chevronUp'}
                                    leftAligned
                                />
                                <CityMapsMap />
                            </div>
                        </Col>
                    </CityMapsProvider>
                </section>
            )}
        </>
    );
};
